exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-dialog > .widget {\n  margin-bottom: 0;\n}\n", ""]);

// exports
